export const language: any = {
  main: "Accueil",
  ingredients: "Ingrédients",
  ai_chef: "Chef IA",
  favorites: "Favoris",
  menu: "Menu",
  get_start: "Commencer",
  title_first_1: "L'IA propose des recettes selon l'âge",
  title_second_1: "Parfaitement organisé du menu à la recette",
  content_1: "Ne vous inquiétez plus des menus quotidiens et des calories. Désormais, obtenez des suggestions de Hey! Cooker",
  title_first_2: "Il fait froid aujourd’hui, vous avez eu une journée difficile.",
  title_second_2: "Pourquoi ne pas essayer un ragoût épicé ce soir ?",
  content_2: "Trouvez la viande en conserve et les nouilles instantanées dans votre réfrigérateur et préparez un dîner simple !",
  my_food_ingredients: "Vous ne savez pas quoi cuisiner ?",
  btn_add_photo: "Choisissez une image ou prenez une photo",
  my_food_reason: "Sélectionnez les ingrédients que vous avez",
  btn_get_cooking: "Obtenez des suggestions de recettes IA",
  enriching_title: "Épanouissez votre corps et votre esprit",
  enriching: "Une collection de recettes",
  photo_registration_title: "Prenez une photo ou téléchargez un reçu<br/>et obtenez des suggestions de menu !",
  photo_registration_content: "Ajoutez du plaisir à la cuisine en identifiant les ingrédients<br/> et en analysant les recettes avec l'IA !",
  food_suggestions_title: "Vous ne savez pas quoi manger ?",
  food_suggestions_sub_title: "Plats à thème",
  our_interests_title: "Créez le menu parfait pour vous et votre famille !",
  our_interests_sub_title: "Choisissez en fonction de l'âge et du sexe.",
  favorite_title: "Une variété de carnets de cuisine",
  weather_title: "Des plats parfaits pour le temps froid",
  video_title: "Découvrez des vidéos dynamiques",
  tag: {
    close: "Fermer",
    open: "Développer"
  },
  no_data: "Aucune donnée",
  update_version_submit: "Mettre à jour maintenant",
  update_version_title: "Une nouvelle version de l'application est disponible.",
  update_version_content: "Pour une expérience optimale, veuillez mettre à jour l'application vers la dernière version.",
  close_btn: "Fermer",
  not_video_id: "Vidéo inexistante",
  favorite_login: "Connectez-vous ou inscrivez-vous pour enregistrer vos recettes préférées.",
  favorite_section_title: "N'oubliez pas de consulter vos recettes enregistrées",
  favorite_section_description: "Mes recettes favorites",
  discover: "Découvrir",
  my_cooker: "Ma cuisine",
  view_recipe: "Voir les recettes à partir des ingrédients sélectionnés",
  my_ingredient: "Mes ingrédients",
  add_ingredient: "Ajouter mes ingrédients",
  video_section_title: "Explorez et ressentez à travers les vidéos",
  video_section_description: "Vidéos de cuisine recommandées",
  age_10: "Moins de 10 ans",
  age_10_to_20: "10-20 ans",
  age_20_to_30: "20-30 ans",
  age_30_to_40: "30-40 ans",
  age_40_to_50: "40-50 ans",
  age_more_50: "50 ans et plus",
  suggest_section_title: "Hey! Cooker vous aide à choisir",
  suggest_section_description: "Quels sujets vous intéressent ?",
  weather_title1: "Suggestions du jour",
  weather_title2: "Que manger par un jour de pluie et de froid ?",
  tasteSuggestion1: "Régalez vos papilles",
  tasteSuggestion2: "Des saveurs faites pour vous",
  tasteTitle1: "Épicé <br />et tentant",
  tasteTitle2: "Frais et <br />léger",
  tasteTitle3: "Acidulé <br />et excitant",
  tasteTitle4: "Aromatique - <br />sucré",
  tasteTitle5: "Équilibré et <br />captivant",
  tasteDescription1: "#sauté #grillé #jour de pluie",
  tasteDescription2: "#frais #fibres #régime",
  tasteDescription3: "#acide #sucré #excitant",
  tasteDescription4: "#unique #épices #magique",
  tasteDescription5: "#goût #nutrition #plaisir",
  suggest_item_title1: "Plats simples",
  suggest_item_description1: "Recettes simples pour le petit déjeuner et le déjeuner",
  suggest_item_title2: "Régime",
  suggest_item_description2: "Faible en glucides<br/>Absolument délicieux",
  suggest_item_title3: "Plats de fin d'année",
  suggest_item_description3: "Plats de fête à la maison",
  suggest_item_title4: "Alimentation saine",
  suggest_item_description4: "Pour un corps et un esprit sains<br/>Faites de meilleurs choix",
  suggest_item_title5: "Snacks simples",
  suggest_item_description5: "Snacks pour un apéritif en solo",
  history: "Historique d'analyse d'images",
  community: {
    sub_title: "Cuisinez avec tout le monde",
    title: "Recherche dans la communauté Hey! Cooker",
    trending: "Tendance",
    follow: "Suivi",
    video: "Vidéo",
    discover: "Découvrir",
    no_data: "Pas de mise à jour de la communauté Hey! Cooker",
    discover_post: "Rechercher plus de publications dans la communauté"
  },
  user_suggest_title1: "Suggestions du jour",
  user_suggest_title2: "Suggestions de recettes aléatoires"
}
